import React, { Component } from 'react';
import { __, __n } from 'i18n-for-browser';

import Table from '../elements/Table';
import GoBackButton from "../elements/GoBackButton";
import ContentContainer from "../elements/ContentContainer";
import connect from "react-redux/es/connect/connect";
import apiCall from "../apiCall";
import Loading from '../elements/Loading';
import savedIcon from '../../assets/img/icons/check.svg';
import { cookie } from 'glxl-helpers';
import config from '../../config';

class SchoolPortalClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: undefined,
      saving: false,
      saved: false,
      loading: true,
      downloading: false,
      schoolClass: {
        className: '',
        classRoom: '',
        Groups: [
          {
            name: "LAND ROOD",
            GroupThemeId: 1,
            GroupTheme: {
              color: 'red',
            },
            Students: [
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
            ],
          },
          {
            name: "LAND ORANJE",
            GroupThemeId: 2,
            GroupTheme: {
              color: 'orange',
            },
            Students: [
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
            ],
          },
          {
            name: "LAND GEEL",
            GroupThemeId: 3,
            GroupTheme: {
              color: 'yellow',
            },
            Students: [
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
            ],
          },
          {
            name: "LAND GROEN",
            GroupThemeId: 4,
            GroupTheme: {
              color: 'green',
            },
            Students: [
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
            ],
          },
          {
            name: "LAND BLAUW",
            GroupThemeId: 5,
            GroupTheme: {
              color: 'blue',
            },
            Students: [
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
            ],
          },
          {
            name: "LAND PAARS",
            GroupThemeId: 6,
            GroupTheme: {
              color: 'purple',
            },
            Students: [
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
              { name: '' },
            ],
          },
        ],
      },
    }

    this.interval = 0;

    this.errorMessageInterval = 0;

    // Set schoolClassId
    this.schoolClassId = parseInt(this.props.match.params.action, 10);
    if (isNaN(this.schoolClassId)) {
      this.schoolClassId = undefined;
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }

    if (this.errorMessageInterval) {
      clearInterval(this.errorMessageInterval);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // We got the project!
    if (nextProps.project.id !== this.props.project.id && !this.schoolClassId) {
      this.translateGroupNames(nextProps);
    }
  }

  componentWillMount() {
    if (this.schoolClassId) {
      apiCall(`/schoolClass/${this.schoolClassId}`, null, 'GET')
        .then((schoolClass) => {
          this.setState({
            loading: false,
            schoolClass: {
              ...schoolClass,
              Groups: schoolClass.Groups.filter(g => g.active).map((group, i) => {
                while(group.Students.length < 6) {
                  group.Students.push({ name: '' });
                }
                return group;
              }),
            }
          });
        });
    } else {
      this.translateGroupNames();
      this.setState({ loading: false });
    }
    document.body.classList.add('schoolPage');
  }


  translateGroupNames = (props = this.props) => {
    const schoolClass = { ...this.state.schoolClass };
    schoolClass.Groups = schoolClass.Groups.map((g) => {
      if (!props.project.defaultLanguage || !window.translations) return g;
      return {
        ...g,
        name: window.translations[props.project.defaultLanguage.code][g.name] || g.name,
      };
    });
    this.setState({ schoolClass });
  };

  handleChange = ({ target: { value, name } }) => {
    const { schoolClass } = this.state;
    let maxLen = 5;
    if (name === 'className') {
      maxLen = 5;
    }

    if (value.length <= maxLen) {
      schoolClass[name] = value;

      this.setState({schoolClass});
    } else {
      // To big
    }
  };

  downloadPdf = async () => {
    if (this.state.downloading) return false;
    const token = cookie.getCookie('token');
    window.open(`${config.apiUrl}/pdf/groupLayout/${parseInt(this.props.match.params.action, 10)}?authorization=${token}`, '_blank');
  };

  handleStudentUpdate = ({ target: { name, value } }, groupIndex, studentIndex) => {
    value = value.substring(0, 35);
    const { schoolClass } = this.state;
    const group = schoolClass.Groups[groupIndex];
    if (group) {
     const student = group.Students[studentIndex];
     if (student) {
       student[name] = value;
     } else {
      group.Students.push({ [name]: value });
     }
     this.setState({ schoolClass });
    }
  };

  validateSchoolClass = (schoolClass) => {
    if (this.errorMessageInterval) {
      clearInterval(this.errorMessageInterval);
    }
    if (!(schoolClass.className && schoolClass.className.length >= 1 && schoolClass.className.length < 7)) {
      this.setState({ errorMessage: 'sim_klas_verplicht_veld_melding' });
      this.errorMessageInterval = setInterval(() => {
        this.setState({ errorMessage: undefined });
      }, 5000);
      return false;
    }
    const invalidGroup = schoolClass.Groups.find((g) => {
      const validStudents = Array.isArray(g.Students) ? g.Students.filter(s => s.name && s.name.length > 0) : [];
      return validStudents.length < 2 || validStudents.length > 6;
    });
    if (invalidGroup) {
      this.setState({ errorMessage: 'sim_klas_minimaal_2_studenten_per_klas_melding' });
      this.errorMessageInterval = setInterval(() => {
        this.setState({ errorMessage: undefined });
      }, 5000);
      return false;
    }
    return true;
  };

  handleCreateSchoolClass = (ev) => {
    if (this.state.saving || this.props.project.schoolClassesLocked) return false;
    ev.preventDefault();
    const { schoolClass } = this.state;
    const { project } = this.props;
    const valid = this.validateSchoolClass(schoolClass);
    if (!valid) return;
    this.setState({ saving: true });
    apiCall(`/schoolClass`, { ...schoolClass, ProjectId: project.id }, 'POST')
      .then((result) => {
        sessionStorage.setItem('showGroepsIndeling', 'true');
        this.props.history.push('/portal/school');
      });
  };

  handleUpdateSchoolClass = (ev) => {
    if (this.state.saving || this.props.project.schoolClassesLocked) return false;
    ev.preventDefault();
    const valid = this.validateSchoolClass(this.state.schoolClass);
    if (!valid) return;
    this.setState({ saving: true });
    if (this.interval) {
      clearInterval(this.interval);
    }
    apiCall(`/schoolClass/${this.schoolClassId}`, this.state.schoolClass, 'PUT')
      .then(() => {
        this.setState({ saving: false, saved: true });
        this.interval = setInterval(() => {
          this.setState({ saved: false });
        }, 5000);
      });
  };

  getClassInput = (groups) => {
    return groups.map((group, groupIndex) => {
      const studentInputs = [];
      while(studentInputs.length < 6) {
        const studentIndex = studentInputs.length;
        const student = group.Students[studentIndex];
        studentInputs.push([
          <div className={`student-container`}>
            <input type='text'
              name="name"
              placeholder={__('sim_naam_teamlid_placeholder')}
              value={student ? student.name : ''}
              onChange={(ev) => { this.handleStudentUpdate(ev, groupIndex, studentIndex)}}/>
          </div>
        ]);
      }
      return (
        <div className="groupInputEntry" key={`form-${groupIndex}`}>
            <Table
              translate={false}
              className="school-contact-group-layout"
              headColor={group.GroupTheme.color}
              headTextColor='white'
              head={[<span style={{ position: 'relative', top: '2px' }}>{group.name}</span>]}
              body={studentInputs}/>
          </div>
      );
    }, []);
  };

  render() {
    const { schoolClass, loading } = this.state;
    if (loading) return <Loading />;
    return (
      <div className="portal-home portal-school-classManagement darkBckg">
        <div className="desktop-content-center" style={{ maxWidth: 600 }}>
          <div className="container container--semiwide" style={{ minWidth: 600 }}>
            <div className="content-container">
              <div className="content-container-background"/>
              <form>
                <div className="input-container inline-input">
                  <label style={{ width: 'auto', marginRight: 20 }}>{__n('sim_klas', 1)}:</label>
                  <input type="text"
                         placeholder={__('sim_invoer_verplicht_placeholder')}
                         value={schoolClass.className}
                         name='className'
                         onChange={(ev) => { this.handleChange(ev)}}/>
                </div>
                <div className="input-container inline-input">
                  <label style={{ width: 'auto', marginRight: 20 }}>{__n('sim_lokaal', 1)}:</label>
                  <input type="text"
                         placeholder={__('sim_invoer_optioneel_placeholder')}
                         value={schoolClass.classRoom}
                         name='classRoom'
                         onChange={(ev) => { this.handleChange(ev)}}/>
                </div>
              </form>
            </div>
            <GoBackButton history={this.props.history}/>
          </div>
        </div>

        <div className="container classInput">
          {this.getClassInput(schoolClass.Groups)}
        </div>

        <div className="desktop-content-center">
          <div className="buttonRow center buttonRow--wide">
            {this.props.match.params.action !== 'add' ?
              <button className={`button${(this.state.downloading ? ' disabled' : '')}`} onClick={this.downloadPdf}><span>PDF {__('sim_groepsindeling')}</span></button>
              : ''
            }
            <button disabled={this.state.saving || this.props.project.schoolClassesLocked} className={`button${(this.state.saving || this.props.project.schoolClassesLocked ? ' disabled' : '')}`} onClick={this.schoolClassId ? this.handleUpdateSchoolClass : this.handleCreateSchoolClass}><span>{__('sim_opslaan')}</span></button>
            {this.state.saved ? <img src={savedIcon} style={{ height: '30px', position: 'absolute', right: '-35px' }} alt="" /> : null}
          </div>
          {this.state.errorMessage ? (
            <ContentContainer style={{
              padding: '15px 24px',
              width: 'fit-content',
              margin: '10px auto',
            }}>
              <p>{__(this.state.errorMessage)}</p>
            </ContentContainer>
          ) : null}
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  project: state.project,
}))(SchoolPortalClass);



// WEBPACK FOOTER //
// ./src/components/desktop/SchoolPortalClass.js